import {DescriptionText, H1Text, H2Text, Text} from "../../../../../design";
import React from "react";
import {AmountDivideByHundred} from "../../../../../helper";
import SmallScreenHeader from "../../../../../components/smallscreen/header";
import currencyformatter from "../../../../../utils/currencyformatter";
import getformatteddate from "../../../../../utils/getformatteddate";

type Props = {
  subscription: Object,
  timeZone: string
}

const Header = (props:Props) => {
  const {subscription, timeZone} = props;
  return (
    <SmallScreenHeader>
      <H1Text>ADD PAYMENT METHOD</H1Text>
      <H2Text>Payment For</H2Text>
      <DescriptionText>
        {subscription && subscription.description}
      </DescriptionText>
      <H2Text>
        Amount Payable
      </H2Text>
      <DescriptionText>
        {subscription ? `${currencyformatter(AmountDivideByHundred(subscription.amount), subscription.currency && subscription.currency.name)}` : null }
      </DescriptionText>
      <Text
        hidden={!(subscription && (subscription.totalSuccessfulPayments === 0) && (subscription.upfrontAmount !== 0))}
        fontSize="12px"
        marginBottom="20px"
        color="#6b6c6f"
        lineHeight="21px"
      >
        A one-time upfront charge of&nbsp;<span style={{fontWeight:"600", color: "black"}}>
            {subscription && currencyformatter(AmountDivideByHundred(subscription.upfrontAmount), subscription.currency && subscription.currency.name)}
          </span>&nbsp;will be added to the first payment.
      </Text>
      <H2Text>
        NEXT PAYMENT DUE ON
      </H2Text>
      <DescriptionText>
        {subscription && subscription.nextPaymentDate && getformatteddate(subscription.nextPaymentDate, timeZone)}
      </DescriptionText>
    </SmallScreenHeader>
  )
};

export default Header;
